module.exports = __webpack_public_path__ + "8c60b89e9b9f0a0ea984992e90c3e2ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-basic-2.png
// module id = 3190
// module chunks = 0